module.exports = __webpack_public_path__ + "static/media/SCALE.2d2307de.gif";